import { sendAuthRequest } from ".";
import { UserDataMapper } from "../mappers/userMapper";

const USER_URL = '/api/profile';

export const getUserStatistics = async () => {
    const response = await sendAuthRequest(`${USER_URL}/me`, 'GET');
    return UserDataMapper.toDomainModel(response);
};